/**
 * Created by Ella Ma on 03/26/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FilterPanelConfig, FilterPanelEvents, FilterPanelActions } from '../../../../widgets/filter-item/filter-panel/filter-panel.view-model';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TileFilterConfig, TileFilterEventType, StandardFilterItems, StartDateFilter } from './tile-filter.model';
import { TileFilterService } from '../../../../tamalelibs/services/tile-filter.service';
import { FilterMetadataType } from '../../../../tamalelibs/components/filter-config';
import { EntityService } from '../../../../tamalelibs/services/entity.service';
import * as _lodash from 'lodash';
import { FieldConfig, FieldConfigData, FieldEventType } from '../../../../widgets/field-selector/field-selector.model';
import { CURRENT_USER } from '../../../../tamalelibs/constants/business.constants';

@Component({
    selector: 'tam-tile-filter',
    templateUrl: './tile-filter.component.html',
    styleUrls: ['./tile-filter.component.scss']
})
export class TileFilterComponent implements OnInit, OnDestroy {

    @Input() config: TileFilterConfig;
    filterConfig: FilterPanelConfig;
    fieldConfig: FieldConfig;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _tileFilterService: TileFilterService,
        private _entityService: EntityService
    ) { }

    ngOnInit() {
        this.filterConfig = new FilterPanelConfig();
        this.filterConfig.isShowDynamicDate = true;
        this.initFieldSelector();
        this.initFilter();
        this.fieldConfigSubject();
        this.filterConfigSubject();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    getNewEntityInfo() {
        const entityIds = [];
        const needUpdate = (item) => {
            return item.metadataType === FilterMetadataType.Entity || item.metadataType === FilterMetadataType.Source ||
                item.metadataType === FilterMetadataType.Submitter || item.metadataType === FilterMetadataType.Team;
        };
        this.filterConfig.filtersConfigList.forEach(item => {
            if (needUpdate(item) && item.value) {
                item.value.forEach(val => {
                    if (val.id !== CURRENT_USER.id) {
                        entityIds.push(val.id);
                    }
                });
                const index = item.value.findIndex(data => data.id === CURRENT_USER.id);
                if (index !== -1) {
                    item.value[index] = CURRENT_USER;
                }
            }
        });
        this.changeTileFilter();
        if (entityIds.length !== 0) {
            this._entityService.getEntityListByIdsQuick(entityIds).pipe(
                map(response => this._entityService.mapEntityBriefList(response)),
                map(entities => {
                    const entityMap = new Map();
                    entities.forEach(element => entityMap.set(element.id, element));
                    return entityMap;
                })
            ).subscribe((entityMap => {
                this.filterConfig.filtersConfigList.forEach(item => {
                    if (needUpdate(item) && item.value) {
                        item.value = item.value.map(element => {
                            if (entityMap.has(element.id)) {
                                return entityMap.get(element.id);
                            }
                            return element;
                        });
                        item.value = item.value.filter(value => !!value);
                    }
                });
                this.changeTileFilter();
            }));
        }
    }

    changeTileFilter() {
        this.filterConfig.action$.next({ type: FilterPanelActions.reloadFilter, payload: this.filterConfig.filtersConfigList });
        this.config.events$.next({ type: TileFilterEventType.change, payload: this.filterConfig.filtersConfigList });
    }

    initFilter() {
        this.filterConfig.filtersConfigList = _lodash.cloneDeep(this.config.config);
        this.getNewEntityInfo();
    }

    initFieldSelector() {
        this.fieldConfig = new FieldConfig();
        this.fieldConfig.config = new FieldConfigData();
        this.fieldConfig.config.standardItem = StandardFilterItems;
        this.fieldConfig.config.showAdhoc = true;
        this.fieldConfig.config.otherAdhoc = [StartDateFilter];
        this.fieldConfig.config.showSearch = true;
    }

    filterConfigSubject() {
        this._destroySubscriptions.push(
            this.filterConfig.events$.pipe(
                filter((data) => data.type === FilterPanelEvents.change || data.type === FilterPanelEvents.delete)
            ).subscribe((data) => {
                this.filterConfig.filtersConfigList = _lodash.cloneDeep(data.payload);
                this.config.events$.next({ type: TileFilterEventType.change, payload: this.filterConfig.filtersConfigList });
            })
        );
    }

    fieldConfigSubject() {
        this._destroySubscriptions.push(
            this.fieldConfig.events$.pipe(
                filter(data => data.type === FieldEventType.select)
            ).subscribe((data) => {
                let filtersConfig;
                if (data.payload.type === 'standard') {
                    filtersConfig = this._tileFilterService.getNewFilterDefaultInstance(data.payload.text, data.payload.value);
                } else {
                    filtersConfig = this._tileFilterService.getAdhocFilterDefaultInstance(data.payload);
                }
                this.filterConfig.filtersConfigList.push(filtersConfig);
                this.filterConfig.action$.next({ type: FilterPanelActions.addFilter, payload: [filtersConfig] });
                this.config.events$.next({ type: TileFilterEventType.change, payload: this.filterConfig.filtersConfigList });
            })
        );
    }
}
